import React from 'react';

export function RightArrowSVG ({ customStroke, className = '' }) {
    const stroke = customStroke || '#F95623';
    return (
        <span className={className}>
            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_9752_22969)">
                    <path d="M5.5 12.834H19.5" stroke= {stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M13.5 18.834L19.5 12.834" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M13.5 6.83398L19.5 12.834" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </g>
                <defs>
                    <clipPath id="clip0_9752_22969">
                        <rect width="24" height="24" fill="white" transform="translate(0.5 0.833984)"/>
                    </clipPath>
                </defs>
            </svg>

        </span>
    );
}
